import { render, staticRenderFns } from "./BuyerBlockedChannels.vue?vue&type=template&id=1b39da95&scoped=true"
import script from "./BuyerBlockedChannels.vue?vue&type=script&lang=js"
export * from "./BuyerBlockedChannels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b39da95",
  null
  
)

export default component.exports